import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Aviso padrão das consultas feitas pelo conector Conexão Claro (viabilidade / crédito)
export const ConectorAviso = ({ r, testid = 'conector-aviso' }) => {
  if (!r || r.status === 'ok') return null;
  const amarelo = r.status === 'sem_cobertura' || r.status === 'conector_inativo' || r.status === 'pendente';
  const cor = amarelo
    ? 'border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-200'
    : 'border-red-300 dark:border-red-800 bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300';
  const corpo = r.resultado != null ? (typeof r.resultado === 'string' ? r.resultado : JSON.stringify(r.resultado)) : null;
  return (
    <div className={`rounded-lg border p-3 text-sm ${cor}`} data-testid={testid}>
      <p className="flex items-center gap-2 font-semibold"><AlertTriangle className="w-4 h-4" /> {r.mensagem || 'Não foi possível consultar'}</p>
      {corpo && <pre className="mt-2 max-h-32 overflow-auto rounded bg-white/70 dark:bg-black/30 p-2 text-[11px] font-mono whitespace-pre-wrap break-words text-gray-800 dark:text-gray-200">{corpo.slice(0, 1500)}</pre>}
      {r.requisicao?.url && <p className="mt-1 text-[10px] font-mono opacity-70 break-all">{r.requisicao.metodo} {r.requisicao.url}</p>}
    </div>
  );
};
